<template>
  <div id="map" class="rounded border shadow" style="height: 400px; width: 100%;"></div>
</template>

<script setup>
import { onMounted, nextTick, watch } from 'vue'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

// 🛠️ Путь к иконке (ты можешь использовать другие пути при необходимости)
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: new URL('leaflet/dist/images/marker-icon-2x.png', import.meta.url).href,
  iconUrl: new URL('leaflet/dist/images/marker-icon.png', import.meta.url).href,
  shadowUrl: new URL('leaflet/dist/images/marker-shadow.png', import.meta.url).href
})

const props = defineProps({
  latitude: {
    type: Number,
    required: true
  },
  longitude: {
    type: Number,
    required: true
  }
})

let map, marker

const initMap = () => {
  if (map) {
    map.remove()
  }

  map = L.map('map').setView([props.latitude, props.longitude], 13)

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap contributors'
  }).addTo(map)

  marker = L.marker([props.latitude, props.longitude]).addTo(map)
}

watch(() => [props.latitude, props.longitude], () => {
  initMap()
})

onMounted(() => {
  nextTick(() => {
    initMap()
  })
})
</script>


<style scoped>
#map {
  width: 100%;
}
</style>
